import { render, staticRenderFns } from "./courseAuth.vue?vue&type=template&id=0100c7cc&scoped=true&"
import script from "./courseAuth.vue?vue&type=script&lang=js&"
export * from "./courseAuth.vue?vue&type=script&lang=js&"
import style0 from "./courseAuth.vue?vue&type=style&index=0&id=0100c7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0100c7cc",
  null
  
)

export default component.exports